import { CellContext } from '@tanstack/react-table';

import { BaseCell, BaseCellProps } from './BaseCell';

export interface TextCellProps<TData = unknown, TValue = unknown> extends Omit<
  BaseCellProps,
  'children'
> {
  context?: CellContext<TData, TValue>;
  value?: TValue;
  showPadding?: boolean;
  fullWidth?: boolean;
}

export function TextCell<TData, TValue>({
  context,
  ...props
}: TextCellProps<TData, TValue>) {
  const value = props.value ?? context?.getValue();
  const align = context?.column.columnDef.meta?.align ?? props.align;

  return (
    <BaseCell {...props} align={align}>
      {value != null ? String(value) : ''}
    </BaseCell>
  );
}
